module.exports = __webpack_public_path__ + "img/sentiment-wireframe-2.da076da6.jpg";